import React from "react";
export function UpArrowSVG() {
  return (
    <svg
      aria-hidden="true"
      height="15"
      viewBox="0 0 15 15"
      width="15"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 11V3.5M7.5 3.5L10.5 6.5M7.5 3.5L4.5 6.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
